  document.addEventListener("DOMContentLoaded", function () {
        const tabs = document.querySelectorAll(".template-tabs-section-tab");
        const contents = document.querySelectorAll(".tab-content");

        tabs.forEach((tab) => {
          tab.addEventListener("click", function () {
            // Remove active class from all tabs
            tabs.forEach((t) => t.classList.remove("active"));
            // Add active class to clicked tab
            this.classList.add("active");

            // Hide all content sections
            contents.forEach((content) => content.classList.remove("active"));
            // Show the content section that corresponds to the clicked tab
            const tabType = this.getAttribute("data-tab");
            document.querySelector(`.${tabType}`).classList.add("active");
          });
        });

        // Initially display the first tab's content
        document.querySelector(".template-tabs-section-tab.active").click();
      });

      document
        .querySelectorAll(".product-feature--icon")
        .forEach(function (icon) {
          const originalImage = icon.querySelector("img").src;
          const hoverImage = icon.getAttribute("data-hover-image");

          icon.addEventListener("mouseenter", function () {
            icon.querySelector("img").src = hoverImage;
          });

          icon.addEventListener("mouseleave", function () {
            icon.querySelector("img").src = originalImage;
          });
        });

      document
        .querySelectorAll(".product-template--FAQ--question")
        .forEach((question) => {
          question.addEventListener("click", () => {
            const answer = question.nextElementSibling;
            const arrow = question.querySelector(".faq-arrow");
            const isOpen = answer.classList.contains("open");

            // Close all open answers and reset arrows
            document
              .querySelectorAll(".product-template--FAQ--answer.open")
              .forEach((openAnswer) => {
                openAnswer.classList.remove("open");
                openAnswer.style.maxHeight = "0";
                openAnswer.previousElementSibling
                  .querySelector(".faq-arrow")
                  .classList.remove("rotate");
              });

            // If the clicked answer was not open, open it and rotate the arrow
            if (!isOpen) {
              answer.classList.add("open");
              answer.style.maxHeight = answer.scrollHeight + "px";
              arrow.classList.add("rotate");
            }
          });
        });